// extracted by mini-css-extract-plugin
export var dropdownButton = "_2a-0";
export var fullWidthDropdownButton = "_2a-1";
export var icon = "_2a-3";
export var iconPlaceholder = "_2a-2";
export var menuItemRow = "_2a-8";
export var separator = "_2a-c";
export var shortcutContainer = "_2a-7";
export var shortcutIconLg = "_2a-6";
export var shortcutIconMd = "_2a-5";
export var shortcutIconSm = "_2a-4";
export var submenuChevron = "_2a-b";
export var submenuDropdown = "_2a-9";
export var submenuTriggerRow = "_2a-a";